import * as types from "../action/ActionType";
import { ADMIN_STATEMENT_INITIAL} from "../store/InitialStore";

export default function AdminBillingStatementFilterReducer(state = ADMIN_STATEMENT_INITIAL, action) {
  const { type, payload } = action;
  switch (type) {
    case types.ADMIN_BILLING_STATEMENT_SELECT:
      return {
        ...state, // Spread the existing state
        ...payload, // Merge with the new payload
      };
    default:
      return state;
  }
}
